// extracted by mini-css-extract-plugin
module.exports = {"container":"footer-bottom_container__69CKJ","root":"footer-bottom_root__Xubf1"};